"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateForgotPasswordRequestSchema = exports.CandidateRegisterRequestSchema = exports.CandidateAuthorizationHeaderSchema = void 0;
const zod_1 = require("zod");
exports.CandidateAuthorizationHeaderSchema = zod_1.z.object({
    authorization: zod_1.z.string().min(1, 'Authorization header is required'),
});
exports.CandidateRegisterRequestSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    firstName: zod_1.z.string().min(1, 'First name is required'),
    lastName: zod_1.z.string().min(1, 'Last name is required'),
    password: zod_1.z.string().min(6, 'Password must be at least 6 characters long'),
});
exports.CandidateForgotPasswordRequestSchema = zod_1.z.object({ email: zod_1.z.string().email() });
